import React from 'react';
import PropTypes from 'prop-types';
import { useReactToPrint } from 'react-to-print';
import { IconButton, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { useStyles } from '../Style/exportActionStyles';

const ExportActions = ({ graphContainerRef, exportFile }) => {
  const classes = useStyles();
  const exportPDF = useReactToPrint({
    content: () => graphContainerRef.current,
  });
  return (
    <div className={classes.root}>
      <IconButton color="primary" className={classes.iconBtn} onClick={exportFile}>
        <TextSnippetIcon />
        <Typography>Excel</Typography>
      </IconButton>
      <IconButton color="primary" className={classes.iconBtn} onClick={exportPDF}>
        <PictureAsPdfIcon />
        <Typography>PDF</Typography>
      </IconButton>
    </div>
  );
};

ExportActions.propTypes = {
  graphContainerRef: PropTypes.object,
  exportFile: PropTypes.func,
};

export default ExportActions;
